import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TenantAppletService, AppletLanguageHdrTenantService } from 'blg-akaun-ts-lib';
import { ToastrService } from 'ngx-toastr';
import { SessionStates } from '../../../modules/session/session-controller/states';
import { AppConfig } from '../../../visa';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { TranslationActions } from '../actions';
import { AppStates } from '../states';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationEffects {

  apiVisa = AppConfig.apiVisa;

  setLanguage$ = createEffect(() => this.actions$.pipe(
    ofType(TranslationActions.setLanguageInit),
    exhaustMap(action => {
      const appletGuid = sessionStorage.getItem('appletGuid');
      return this.languageService.getAppletLanguageFile(appletGuid, action.language, this.apiVisa).pipe(
        map((translations : any )=> {
          this.translate.setTranslation(action.language, translations, true);
          this.translate.use(action.language);
          return TranslationActions.setLanguageSuccess({ language: action.language, translations: translations });
        }),
        catchError(err => of(TranslationActions.setLanguageFailed({ error: err })))
      );
    })
  ));

  constructor(
    private actions$: Actions,
    private appletService: TenantAppletService,
    private sessionStore: Store<SessionStates>,
    private toastr: ToastrService,
    private languageService: AppletLanguageHdrTenantService,
    private translate: TranslateService,
    private appStore: Store<AppStates>,
  ) { }
}
